var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { attrs: { id: "boxloading" } }),
      _vm._v(" "),
      _c("div", { staticClass: "main-content-inner" }, [
        _c(
          "div",
          {
            staticClass: "breadcrumbs ace-save-state",
            attrs: { id: "breadcrumbs" }
          },
          [
            _c(
              "ul",
              { staticClass: "breadcrumb" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "router-link",
                  { attrs: { tag: "li", to: { name: "user" } } },
                  [_c("a", [_vm._v("ユーザー")])]
                ),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [_vm._v("ユーザー編集")])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "page-content register_user" }, [
          _vm.loading
            ? _c("div", { attrs: { id: "loading" } }, [
                _c("div", { staticClass: "loadingMsg" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _vm.errorMessageLogs !== ""
              ? _c("div", { staticClass: "alert alert-danger" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.errorMessageLogs) +
                      "\n          "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.message
              ? _c("div", { staticClass: "alert alert-success" }, [
                  _vm._v(
                    "\n            " + _vm._s(_vm.message) + "\n          "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 col-sm-2 center userav" }, [
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("span", { staticClass: "profile-picture" }, [
                    _c("img", {
                      staticClass: "thumbnail inline no-margin-bottom",
                      staticStyle: {
                        width: "150px",
                        height: "150px",
                        overflow: "auto"
                      },
                      attrs: {
                        id: "user_avatar",
                        height: "150",
                        widht: "150",
                        alt: "user-avatar",
                        src: _vm.showAvatar(_vm.userInfor.thumbnail)
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c("span", {
                  staticClass: "error_m",
                  attrs: { id: "fileimg_error" }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-sm-10" }, [
                _c("div", { staticClass: "profile-user-info" }, [
                  _vm.sameUser
                    ? _c("div", { staticClass: "alert alert-danger" }, [
                        _c("p", [
                          _vm._v(
                            "(※)の権限は変更できません。変更が必要な場合は、別の管理者に依頼してください。"
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-user-info" }, [
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-id" }, [
                      _vm._v("ユーザーID")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.userId,
                            expression: "userInfor.userId"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          type: "text",
                          disabled: "",
                          placeholder: "ユーザーID"
                        },
                        domProps: { value: _vm.userInfor.userId },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "userId",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c(
                      "div",
                      { staticClass: "profile-info-name" },
                      [
                        _vm._v("ユーザー名（登録名） "),
                        _c("font", { staticClass: "input-required" }, [
                          _vm._v("※必須")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "name_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.name,
                            expression: "userInfor.name"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          type: "text",
                          id: "name",
                          placeholder: "ユーザー名"
                        },
                        domProps: { value: _vm.userInfor.name },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(2)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.userInfor, "name", $event.target.value)
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("ユーザー名（ふりがな）")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "furigana_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.furigana,
                            expression: "userInfor.furigana"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          type: "text",
                          id: "furigana",
                          placeholder: "ふりがな"
                        },
                        domProps: { value: _vm.userInfor.furigana },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(3)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "furigana",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("メールアドレス")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "mailaddress_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.email,
                            expression: "userInfor.email"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          type: "text",
                          id: "mailaddress",
                          placeholder: "example@example.com"
                        },
                        domProps: { value: _vm.userInfor.email },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(4)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "email",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("暗証番号")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "passcode_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.passCode,
                            expression: "userInfor.passCode"
                          }
                        ],
                        staticClass: "form-control input-sm",
                        attrs: {
                          type: "text",
                          id: "passcode",
                          placeholder: "0000"
                        },
                        domProps: { value: _vm.userInfor.passCode },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(5)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "passCode",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("組織管理権限"),
                      _vm.sameUser
                        ? _c("span", { staticClass: "red" }, [_vm._v("(※)")])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.isAdmin,
                            expression: "userInfor.isAdmin"
                          }
                        ],
                        staticClass: "ace ace-switch ace-switch-4",
                        attrs: {
                          name: "switch-field-1",
                          type: "checkbox",
                          disabled: _vm.sameUser
                        },
                        domProps: {
                          checked: Array.isArray(_vm.userInfor.isAdmin)
                            ? _vm._i(_vm.userInfor.isAdmin, null) > -1
                            : _vm.userInfor.isAdmin
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.userInfor.isAdmin,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.userInfor.isAdmin = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.userInfor.isAdmin = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.userInfor, "isAdmin", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lbl" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("ゲート設定権限"),
                      _vm.sameUser
                        ? _c("span", { staticClass: "red" }, [_vm._v("(※)")])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.isPhoneAdmin,
                            expression: "userInfor.isPhoneAdmin"
                          }
                        ],
                        staticClass: "ace ace-switch ace-switch-4",
                        attrs: {
                          name: "switch-field-1",
                          type: "checkbox",
                          disabled: _vm.sameUser
                        },
                        domProps: {
                          checked: Array.isArray(_vm.userInfor.isPhoneAdmin)
                            ? _vm._i(_vm.userInfor.isPhoneAdmin, null) > -1
                            : _vm.userInfor.isPhoneAdmin
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.userInfor.isPhoneAdmin,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.userInfor.isPhoneAdmin = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.userInfor.isPhoneAdmin = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.userInfor, "isPhoneAdmin", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lbl" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("鍵共有権限"),
                      _vm.sameUser
                        ? _c("span", { staticClass: "red" }, [_vm._v("(※)")])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.shareKeyBeValid,
                            expression: "userInfor.shareKeyBeValid"
                          }
                        ],
                        staticClass: "ace ace-switch ace-switch-4",
                        attrs: {
                          name: "switch-field-1",
                          type: "checkbox",
                          disabled: _vm.sameUser
                        },
                        domProps: {
                          checked: Array.isArray(_vm.userInfor.shareKeyBeValid)
                            ? _vm._i(_vm.userInfor.shareKeyBeValid, null) > -1
                            : _vm.userInfor.shareKeyBeValid
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.userInfor.shareKeyBeValid,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.userInfor.shareKeyBeValid = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.userInfor.shareKeyBeValid = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.userInfor, "shareKeyBeValid", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lbl" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("ステータス"),
                      _vm.sameUser
                        ? _c("span", { staticClass: "red" }, [_vm._v("(※)")])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.isValid,
                            expression: "userInfor.isValid"
                          }
                        ],
                        staticClass: "ace ace-switch ace-switch-4",
                        attrs: {
                          name: "switch-field-1",
                          type: "checkbox",
                          disabled: _vm.sameUser
                        },
                        domProps: {
                          checked: Array.isArray(_vm.userInfor.isValid)
                            ? _vm._i(_vm.userInfor.isValid, null) > -1
                            : _vm.userInfor.isValid
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.userInfor.isValid,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.userInfor.isValid = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.userInfor.isValid = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.userInfor, "isValid", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lbl" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("ログインパスワード変更"),
                      _vm.sameUser
                        ? _c("span", { staticClass: "red" }, [_vm._v("(※)")])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", { staticClass: "lblPassword" }, [
                        _vm._v(
                          "\n                      新しいパスワード\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "clearfix cusrow" }, [
                        _c("span", {
                          staticClass: "error_m",
                          attrs: { id: "password_error" }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.credentials.newPassword,
                              expression: "credentials.newPassword"
                            }
                          ],
                          staticClass: "form-control input-sm",
                          attrs: {
                            id: "password",
                            autocomplete: "new-password",
                            disabled: _vm.sameUser,
                            placeholder: "パスワード",
                            name: "password",
                            type: "password"
                          },
                          domProps: { value: _vm.credentials.newPassword },
                          on: {
                            blur: function($event) {
                              _vm.validateBeforeSubmit(0)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.credentials,
                                "newPassword",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "newpassword-showhide" }, [
                        _c(
                          "span",
                          {
                            staticClass: "show-password",
                            on: {
                              click: function($event) {
                                _vm.showhidePassword(
                                  "password",
                                  "show-password",
                                  "newpassword-showhide"
                                )
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../../static/img/eye_off.png"),
                                width: "30"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "hide-password",
                            on: {
                              click: function($event) {
                                _vm.showhidePassword(
                                  "password",
                                  "hide-password",
                                  "newpassword-showhide"
                                )
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../../static/img/eye_on.png"),
                                width: "30"
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "lblPassword" }, [
                        _vm._v(
                          "\n                      新しいパスワード再入力\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "clearfix cusrow" }, [
                        _c("span", {
                          staticClass: "error_m",
                          attrs: { id: "repassword_error" }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.credentials.rePassword,
                              expression: "credentials.rePassword"
                            }
                          ],
                          staticClass: "form-control input-sm",
                          attrs: {
                            id: "repassword",
                            disabled: _vm.sameUser,
                            autocomplete: "new-password",
                            placeholder: "パスワード",
                            name: "password",
                            type: "password"
                          },
                          domProps: { value: _vm.credentials.rePassword },
                          on: {
                            blur: function($event) {
                              _vm.validateBeforeSubmit(1)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.credentials,
                                "rePassword",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "repassword-showhide" }, [
                        _c(
                          "span",
                          {
                            staticClass: "show-password",
                            on: {
                              click: function($event) {
                                _vm.showhidePassword(
                                  "repassword",
                                  "show-password",
                                  "repassword-showhide"
                                )
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../../static/img/eye_off.png"),
                                width: "30"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "hide-password",
                            on: {
                              click: function($event) {
                                _vm.showhidePassword(
                                  "repassword",
                                  "hide-password",
                                  "repassword-showhide"
                                )
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../../static/img/eye_on.png"),
                                width: "30"
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "warringu" }, [
                        _vm._v(
                          "\n                      ログインパスワードは英大文字、英小文字、数字を組み合わせた8文字以上64文字以内で設定してください。\n                    "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("SMS認証")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.isMfaSms,
                            expression: "userInfor.isMfaSms"
                          }
                        ],
                        staticClass: "ace ace-switch ace-switch-4",
                        attrs: {
                          name: "switch-field-1",
                          type: "checkbox",
                          disabled: _vm.isMfa === "false"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.userInfor.isMfaSms)
                            ? _vm._i(_vm.userInfor.isMfaSms, null) > -1
                            : _vm.userInfor.isMfaSms
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.userInfor.isMfaSms,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.userInfor.isMfaSms = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.userInfor.isMfaSms = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.$set(_vm.userInfor, "isMfaSms", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "lbl" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("電話番号")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "phonenumber_error" }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.phoneNumber,
                            expression: "userInfor.phoneNumber"
                          }
                        ],
                        staticClass: "form-control input-sm input",
                        attrs: {
                          type: "text",
                          id: "phonenumber",
                          placeholder: "",
                          disabled: !_vm.isSMS
                        },
                        domProps: { value: _vm.userInfor.phoneNumber },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(8)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "phoneNumber",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "margin-top": "10px" } }, [
                        _vm._v(
                          "0から始まる-(ハイフン)無しの携帯電話番号を11桁で入力してください。"
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("備考.1")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "option1_error" }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.option1,
                            expression: "userInfor.option1"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "option1", placeholder: "備考.1" },
                        domProps: { value: _vm.userInfor.option1 },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(6)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "option1",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile-info-row" }, [
                    _c("div", { staticClass: "profile-info-name" }, [
                      _vm._v("備考.2")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-info-value" }, [
                      _c("span", {
                        staticClass: "error_m",
                        attrs: { id: "option2_error" }
                      }),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userInfor.option2,
                            expression: "userInfor.option2"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "option2", placeholder: "備考.2" },
                        domProps: { value: _vm.userInfor.option2 },
                        on: {
                          blur: function($event) {
                            _vm.validateBeforeSubmit(7)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userInfor,
                              "option2",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12" }, [
                    _c(
                      "div",
                      { staticClass: "action_box" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "btn cancel_bottom",
                            attrs: { to: { name: "user" } }
                          },
                          [
                            _vm._v(
                              "\n                      キャンセル\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-info save_group_bottom",
                            attrs: { type: "button" },
                            on: { click: _vm.submitEditUser }
                          },
                          [
                            _vm._v(
                              "\n                      保存\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion-style1 panel-group",
                attrs: { id: "accordion" }
              },
              [
                _c("div", { staticClass: "panel panel-default" }, [
                  _c("div", { staticClass: "panel-heading" }, [
                    _c("h4", { staticClass: "panel-title" }, [
                      _c(
                        "a",
                        {
                          staticClass: "accordion-toggle",
                          attrs: {
                            "data-toggle": "collapse",
                            href: "#phone",
                            "aria-expanded": "true"
                          },
                          on: {
                            click: function($event) {
                              _vm.getDataPhone()
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass:
                              "ace-icon fa fa-angle-right bigger-110",
                            attrs: {
                              "data-icon-hide": "ace-icon fa fa-angle-down",
                              "data-icon-show": "ace-icon fa fa-angle-right"
                            }
                          }),
                          _vm._v(
                            "\n                     スマートフォン\n                  "
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "panel-collapse collapse",
                      attrs: { id: "phone" }
                    },
                    [
                      _c("div", { staticClass: "panel-body" }, [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-striped table-bordered table-hover dataTable",
                            staticStyle: { "min-width": "100%" }
                          },
                          [
                            _vm._m(3),
                            _vm._v(" "),
                            _vm.listphones != null
                              ? _c(
                                  "tbody",
                                  [
                                    _vm._l(_vm.listphones, function(
                                      item,
                                      index
                                    ) {
                                      return [
                                        _c("tr", { key: index }, [
                                          _c("td", [
                                            _vm._v(_vm._s(item.phoneId))
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(item.model))
                                          ]),
                                          _vm._v(" "),
                                          _c("td", { staticClass: "center" }, [
                                            _vm._v(_vm._s(item.status))
                                          ]),
                                          _vm._v(" "),
                                          _c("td", { staticClass: "center" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.converDate(item.registered)
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _c("tbody", [_vm._m(4)])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "row pd-t-10" }, [
                          _c("div", { staticClass: "col-xs-12" }, [
                            _vm.pagesPhone > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dataTables_paginate paging_simple_numbers"
                                  },
                                  [
                                    _c("paginate", {
                                      attrs: {
                                        "page-count": _vm.pagesPhone,
                                        "page-range": 3,
                                        "margin-pages": 2,
                                        "click-handler":
                                          _vm.handleCurrentChangePhone,
                                        "prev-text": "<<",
                                        "next-text": ">>",
                                        "container-class": "pagination",
                                        "page-class": "page-item"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "panel panel-default" }, [
                  _c("div", { staticClass: "panel-heading" }, [
                    _c("h4", { staticClass: "panel-title" }, [
                      _c(
                        "a",
                        {
                          staticClass: "accordion-toggle",
                          attrs: { "data-toggle": "collapse", href: "#pcode" },
                          on: {
                            click: function($event) {
                              _vm.getDataPcode()
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass:
                              "bigger-110 ace-icon fa fa-angle-right",
                            attrs: {
                              "data-icon-hide": "ace-icon fa fa-angle-down",
                              "data-icon-show": "ace-icon fa fa-angle-right"
                            }
                          }),
                          _vm._v(
                            "\n                     個人コード\n                  "
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "panel-collapse collapse",
                      attrs: { id: "pcode", "aria-expanded": "true" }
                    },
                    [
                      _c("div", { staticClass: "panel-body" }, [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-striped table-bordered table-hover dataTable",
                            staticStyle: { "min-width": "100%" }
                          },
                          [
                            _c("thead", [
                              _c("tr", [
                                _vm.listPcode != null
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "center",
                                        staticStyle: { width: "50px!important" }
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "pos-rel" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.selectAllPcode,
                                                  expression: "selectAllPcode"
                                                }
                                              ],
                                              staticClass: "ace",
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.selectAllPcode
                                                )
                                                  ? _vm._i(
                                                      _vm.selectAllPcode,
                                                      null
                                                    ) > -1
                                                  : _vm.selectAllPcode
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$a = _vm.selectAllPcode,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.selectAllPcode = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.selectAllPcode = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.selectAllPcode = $$c
                                                  }
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "lbl" })
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("th", [_vm._v("個人コードID")]),
                                _vm._v(" "),
                                _c("th", { staticClass: "center" }, [
                                  _vm._v("個人コード種別")
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "center" }, [
                                  _vm._v("ステータス")
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "center" }, [
                                  _vm._v("登録日")
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.listPcode != null
                              ? _c(
                                  "tbody",
                                  [
                                    _vm._l(_vm.listPcode, function(
                                      item,
                                      index
                                    ) {
                                      return [
                                        _c(
                                          "tr",
                                          {
                                            key: index,
                                            class: {
                                              selected: _vm.rowSelectedPcode(
                                                item.pCodeId
                                              )
                                            },
                                            attrs: { id: item.pCodeId }
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "center" },
                                              [
                                                _c(
                                                  "label",
                                                  { staticClass: "pos-rel" },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.selectedPcodeId,
                                                          expression:
                                                            "selectedPcodeId"
                                                        }
                                                      ],
                                                      staticClass: "ace",
                                                      attrs: {
                                                        type: "checkbox"
                                                      },
                                                      domProps: {
                                                        value: item.pCodeId,
                                                        checked: Array.isArray(
                                                          _vm.selectedPcodeId
                                                        )
                                                          ? _vm._i(
                                                              _vm.selectedPcodeId,
                                                              item.pCodeId
                                                            ) > -1
                                                          : _vm.selectedPcodeId
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$a =
                                                              _vm.selectedPcodeId,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v =
                                                                item.pCodeId,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                (_vm.selectedPcodeId = $$a.concat(
                                                                  [$$v]
                                                                ))
                                                            } else {
                                                              $$i > -1 &&
                                                                (_vm.selectedPcodeId = $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  ))
                                                            }
                                                          } else {
                                                            _vm.selectedPcodeId = $$c
                                                          }
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "lbl"
                                                    })
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(item.pCodeId))
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "center" },
                                              [_vm._v(_vm._s(item.type))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "center" },
                                              [
                                                item.isValid
                                                  ? _c("span", [_vm._v("有効")])
                                                  : _c("span", [_vm._v("無効")])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "center" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.converDate(
                                                      item.registered
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _c("tbody", [_vm._m(5)])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "row pd-t-10" }, [
                          _c("div", { staticClass: "col-xs-12" }, [
                            _vm.pagesPcode > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dataTables_paginate paging_simple_numbers"
                                  },
                                  [
                                    _c("paginate", {
                                      attrs: {
                                        "page-count": _vm.pagesPcode,
                                        "page-range": 3,
                                        "margin-pages": 2,
                                        "click-handler":
                                          _vm.handleCurrentChangePcode,
                                        "prev-text": "<<",
                                        "next-text": ">>",
                                        "container-class": "pagination",
                                        "page-class": "page-item"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-cus btn-right btn-add",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.addPcode(_vm.userInfor.userId)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                  個人コードの関連付けを追加\n                  "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "btn-cus btn-right btn-delete",
                            attrs: {
                              href: "#processPcode",
                              "data-toggle": "modal"
                            },
                            on: {
                              click: function($event) {
                                _vm.resetStatus()
                              }
                            }
                          },
                          [_vm._v("チェックした個人コードの関連付け解除")]
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "panel panel-default" }, [
                  _c("div", { staticClass: "panel-heading" }, [
                    _c("h4", { staticClass: "panel-title" }, [
                      _c(
                        "a",
                        {
                          staticClass: "accordion-toggle",
                          attrs: {
                            "data-toggle": "collapse",
                            href: "#gatepassage"
                          },
                          on: {
                            click: function($event) {
                              _vm.getDataGate()
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass:
                              "bigger-110 ace-icon fa fa-angle-right",
                            attrs: {
                              "data-icon-hide": "ace-icon fa fa-angle-down",
                              "data-icon-show": "ace-icon fa fa-angle-right"
                            }
                          }),
                          _vm._v(
                            "\n                     期限付きゲート\n                  "
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "panel-collapse collapse",
                      attrs: { id: "gatepassage", "aria-expanded": "true" }
                    },
                    [
                      _c("div", { staticClass: "panel-body" }, [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-striped table-bordered table-hover dataTable",
                            staticStyle: { "min-width": "100%" }
                          },
                          [
                            _c("thead", [
                              _c("tr", [
                                _vm.loopListGatePassages != null
                                  ? _c(
                                      "th",
                                      {
                                        staticClass: "center",
                                        staticStyle: { width: "50px!important" }
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "pos-rel" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.selectAllGate,
                                                  expression: "selectAllGate"
                                                }
                                              ],
                                              staticClass: "ace",
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.selectAllGate
                                                )
                                                  ? _vm._i(
                                                      _vm.selectAllGate,
                                                      null
                                                    ) > -1
                                                  : _vm.selectAllGate
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$a = _vm.selectAllGate,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.selectAllGate = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.selectAllGate = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.selectAllGate = $$c
                                                  }
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "lbl" })
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("th", [_vm._v("ゲートID")]),
                                _vm._v(" "),
                                _c("th", [_vm._v("ゲート名")]),
                                _vm._v(" "),
                                _c("th", { staticClass: "center" }, [
                                  _vm._v("開始日時")
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "center" }, [
                                  _vm._v("終了日時")
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.loopListGatePassages != null
                              ? _c(
                                  "tbody",
                                  [
                                    _vm._l(_vm.loopListGatePassages, function(
                                      item,
                                      index
                                    ) {
                                      return [
                                        item.gateId.isValid
                                          ? _c(
                                              "tr",
                                              {
                                                key: index,
                                                class: {
                                                  selected: _vm.rowSelectedPassage(
                                                    item.passageId
                                                  )
                                                },
                                                attrs: { id: item.passageId }
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  { staticClass: "center" },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass: "pos-rel"
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.selectedPassageId,
                                                              expression:
                                                                "selectedPassageId"
                                                            }
                                                          ],
                                                          staticClass: "ace",
                                                          attrs: {
                                                            type: "checkbox"
                                                          },
                                                          domProps: {
                                                            value:
                                                              item.passageId,
                                                            checked: Array.isArray(
                                                              _vm.selectedPassageId
                                                            )
                                                              ? _vm._i(
                                                                  _vm.selectedPassageId,
                                                                  item.passageId
                                                                ) > -1
                                                              : _vm.selectedPassageId
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              var $$a =
                                                                  _vm.selectedPassageId,
                                                                $$el =
                                                                  $event.target,
                                                                $$c = $$el.checked
                                                                  ? true
                                                                  : false
                                                              if (
                                                                Array.isArray(
                                                                  $$a
                                                                )
                                                              ) {
                                                                var $$v =
                                                                    item.passageId,
                                                                  $$i = _vm._i(
                                                                    $$a,
                                                                    $$v
                                                                  )
                                                                if (
                                                                  $$el.checked
                                                                ) {
                                                                  $$i < 0 &&
                                                                    (_vm.selectedPassageId = $$a.concat(
                                                                      [$$v]
                                                                    ))
                                                                } else {
                                                                  $$i > -1 &&
                                                                    (_vm.selectedPassageId = $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      ))
                                                                }
                                                              } else {
                                                                _vm.selectedPassageId = $$c
                                                              }
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass: "lbl"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(item.gateId.gateId)
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(item.gateId.gateName)
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "center" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.converDate(
                                                          item.notBefore
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "center" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.converDate(
                                                          item.notAfter
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _c("tbody", [
                                  _c("tr", [
                                    _c("td", { attrs: { colspan: "4" } }, [
                                      _vm._v(_vm._s(_vm.messageGate))
                                    ])
                                  ])
                                ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "row pd-t-10" }, [
                          _c("div", { staticClass: "col-xs-12" }, [
                            _vm.pagesGate > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dataTables_paginate paging_simple_numbers"
                                  },
                                  [
                                    _c("paginate", {
                                      attrs: {
                                        "page-count": _vm.pagesGate,
                                        "page-range": 3,
                                        "margin-pages": 2,
                                        "click-handler":
                                          _vm.handleCurrentChangeGate,
                                        "prev-text": "<<",
                                        "next-text": ">>",
                                        "container-class": "pagination",
                                        "page-class": "page-item"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-cus btn-right btn-add",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.addGatePassage(_vm.userInfor.userId)
                              }
                            }
                          },
                          [_vm._v("ゲートの関連付けを追加\n                  ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "btn-cus btn-right btn-delete",
                            attrs: {
                              href: "#processGate",
                              "data-toggle": "modal"
                            },
                            on: {
                              click: function($event) {
                                _vm.resetStatus()
                              }
                            }
                          },
                          [_vm._v("チェックしたゲートの関連付け解除")]
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "panel panel-default" }, [
                  _c("div", { staticClass: "panel-heading" }, [
                    _c("h4", { staticClass: "panel-title" }, [
                      _c(
                        "a",
                        {
                          staticClass: "accordion-toggle",
                          attrs: {
                            "data-toggle": "collapse",
                            href: "#Passages"
                          },
                          on: {
                            click: function($event) {
                              _vm.getDataGateGroup()
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass:
                              "bigger-110 ace-icon fa fa-angle-right",
                            attrs: {
                              "data-icon-hide": "ace-icon fa fa-angle-down",
                              "data-icon-show": "ace-icon fa fa-angle-right"
                            }
                          }),
                          _vm._v(
                            "\n                     解錠可能ゲート\n                  "
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "panel-collapse collapse",
                      attrs: { id: "Passages", "aria-expanded": "true" }
                    },
                    [
                      _c("div", { staticClass: "panel-body" }, [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-striped table-bordered table-hover dataTable",
                            staticStyle: { "min-width": "100%" }
                          },
                          [
                            _vm._m(6),
                            _vm._v(" "),
                            _vm.listGroupPassages != null &&
                            _vm.listGroupPassages.length > 0
                              ? _c(
                                  "tbody",
                                  [
                                    _vm._l(_vm.listGroupPassages, function(
                                      item,
                                      index
                                    ) {
                                      return [
                                        item.gate.isValid
                                          ? _c("tr", { key: index }, [
                                              _c("td", [
                                                _vm._v(_vm._s(item.gate.gateId))
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(item.gate.name))
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(item.group.name))
                                              ])
                                            ])
                                          : _vm._e()
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _c("tbody", [
                                  _c("tr", [
                                    _c("td", { attrs: { colspan: "3" } }, [
                                      _vm._v(_vm._s(_vm.messageGroup))
                                    ])
                                  ])
                                ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "row pd-t-10" }, [
                          _c("div", { staticClass: "col-xs-12" }, [
                            _vm.pagesPassage > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dataTables_paginate paging_simple_numbers"
                                  },
                                  [
                                    _c("paginate", {
                                      attrs: {
                                        "page-count": _vm.pagesPassage,
                                        "page-range": 3,
                                        "margin-pages": 2,
                                        "click-handler":
                                          _vm.handleCurrentChangePassage,
                                        "prev-text": "<<",
                                        "next-text": ">>",
                                        "container-class": "pagination",
                                        "page-class": "page-item"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn-cus btn-right btn-add",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.addPassage(_vm.userInfor.userId)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                  ゲートグループの関連付けを追加\n                  "
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "processPcode", tabindex: "-1" }
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("span", { staticClass: "progress-question" }, [
                _vm._v("このユーザーとの関連付けを解除しますか？")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "progress",
                  class: {
                    "progress-striped": !_vm.success,
                    active: !_vm.success,
                    hide: !_vm.success
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "progress-bar", style: _vm.progressWidth },
                    [
                      _c("span", [
                        _vm._v(_vm._s(Math.round(_vm.progress)) + "%")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.successPcode > 0
                ? _c("span", { staticClass: "success-label" }, [
                    _vm._v(
                      _vm._s(_vm.countPcode) +
                        "件中" +
                        _vm._s(_vm.successPcode) +
                        "件を解除しました。"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errorMessage.length > 0
                ? _c("div", [
                    _c("span", { staticClass: "error-box-title" }, [
                      _vm._v("解除失敗")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "error-box" },
                      [
                        _vm._l(_vm.errorMessage, function(item) {
                          return [
                            _c("p", {
                              key: item,
                              domProps: { innerHTML: _vm._s(item) }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v("OK")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-danger pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { disabled: _vm.isDisabled },
                      on: {
                        click: function($event) {
                          _vm.deleteRelationPcode()
                        }
                      }
                    },
                    [_vm._v("実行")]
                  )
                : _vm._e()
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "processGate", tabindex: "-1" }
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(8),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("span", { staticClass: "progress-question" }, [
                _vm._v("このゲートとの関連付けを解除しますか？")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "progress",
                  class: {
                    "progress-striped": !_vm.success,
                    active: !_vm.success,
                    hide: !_vm.success
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "progress-bar", style: _vm.progressWidth },
                    [
                      _c("span", [
                        _vm._v(_vm._s(Math.round(_vm.progress)) + "%")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.successGate > 0
                ? _c("span", { staticClass: "success-label" }, [
                    _vm._v(
                      _vm._s(_vm.countGate) +
                        "件中" +
                        _vm._s(_vm.successGate) +
                        "件を削除しました。"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.errorMessage.length > 0
                ? _c("div", [
                    _c("span", { staticClass: "error-box-title" }, [
                      _vm._v("解除失敗")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "error-box" },
                      [
                        _vm._l(_vm.errorMessage, function(item) {
                          return [
                            _c("p", {
                              key: item,
                              domProps: { innerHTML: _vm._s(item) }
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-success pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v("OK")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.success
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-danger pull-right",
                      staticStyle: { width: "100px" },
                      attrs: { disabled: _vm.isDisabled },
                      on: {
                        click: function($event) {
                          _vm.deleteRelationGate()
                        }
                      }
                    },
                    [_vm._v("実行")]
                  )
                : _vm._e()
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal fade", attrs: { id: "question", tabindex: "-1" } },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(9),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-success",
                  staticStyle: { width: "100px" },
                  attrs: { "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.yesChoice()
                    }
                  }
                },
                [_vm._v("送信する")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm",
                  staticStyle: { width: "100px" },
                  attrs: { "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.noChoice()
                    }
                  }
                },
                [_vm._v("送信しない")]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
      _vm._v(" "),
      _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("h3", [_vm._v("ユーザー編集")])
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticStyle: { display: "none" },
          attrs: { href: "#question", id: "xacnhan", "data-toggle": "modal" }
        },
        [_vm._v("show")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
      _c(
        "label",
        {
          staticClass: "btn-upload",
          staticStyle: {
            background: "black",
            color: "white",
            padding: "5px 15px",
            "margin-top": "10px",
            cursor: "pointer"
          },
          attrs: { for: "file_user_avatar" }
        },
        [
          _vm._v("\n                  画像ファイルを選択\n                  "),
          _c("input", {
            staticStyle: { display: "none" },
            attrs: {
              type: "file",
              name: "avatar",
              id: "file_user_avatar",
              accept: "image/png"
            }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("スマートフォンID")]),
        _vm._v(" "),
        _c("th", [_vm._v("端末名")]),
        _vm._v(" "),
        _c("th", { staticClass: "center" }, [_vm._v("ステータス")]),
        _vm._v(" "),
        _c("th", { staticClass: "center" }, [_vm._v("登録日")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "4" } }, [_vm._v("データーはありません")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "4" } }, [_vm._v("データーはありません")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("ゲートID")]),
        _vm._v(" "),
        _c("th", [_vm._v("ゲート名")]),
        _vm._v(" "),
        _c("th", [_vm._v("ゲートグループ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("関連付け解除")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "smaller lighter frofile-title no-margin" }, [
        _vm._v("関連付け解除")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("div", [
        _vm._v(
          "\n            編集したユーザーのメールアドレスへ通知メールを送信しますか？\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f8bdba2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f8bdba2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/UserEdit.vue
// module id = null
// module chunks = 